module.exports = __webpack_public_path__ + "img/pin-in-7.daa21bb1.svg";